<script setup lang="ts">
import type { Guest } from "@/models"
import { computed, useTemplateRef } from "vue"
import { Menu, MenuItem } from "@/components/legacy"
import { Icon } from "@/components/ui"
import { useTranslation } from "@/composables"

const { guest } = defineProps<RsvpListActionsMenuProps>()
const emit = defineEmits<{
  (e: "update", guest?: Guest): void
  (e: "delete", guest?: Guest): void
}>()

interface RsvpListActionsMenuProps {
  guest?: Guest
}

const { t } = useTranslation()

const menuRef = useTemplateRef("menuRef")

function onItemClick(cb: (v?: number) => void, dismiss: boolean = false) {
  if (dismiss) {
    menuRef.value?.toggle()
  }

  cb()
}

const displayMenu = computed(() => !guest?.picsCount && !guest?.vidsCount && !guest?.messagesCount)
</script>

<template>
  <Menu v-if="displayMenu" ref="menuRef" data-test="actions-menu">
    <template #activator="{ toggle }">
      <button class="cursor-pointer" @click="toggle">
        <Icon icon="MenuEllipsisHorizontal" class="p-0 hover:text-gray-300" />
        <span class="sr-only">{{ t("rsvp_list_actions_menu.menu_sr") }}</span>
      </button>
    </template>

    <template #default="{ toggle, isOpen }">
      <div v-show="isOpen" class="flex flex-col gap-2">
        <MenuItem
          :item="{
            key: 'update',
            label: t('rsvp_list_actions_menu.update_guest'),
            icon: 'Edit',
            onClick: () => onItemClick(() => {
              emit('update', guest)
              toggle()
            }),
          }"
        />

        <MenuItem
          :item="{
            key: 'delete',
            label: t('rsvp_list_actions_menu.delete_guest'),
            variant: 'danger',
            icon: 'Trash',
            onClick: () => onItemClick(() => {
              emit('delete', guest)
              toggle()
            }),

          }"
        />
      </div>
    </template>
  </Menu>
</template>
